import { cn } from '@/utils/cn'
import { formatUSD } from '@vaultsfyi/common/utils'
import { type VariantProps, cva } from 'class-variance-authority'
import { Badge } from '../common/badge'

const positionBadgeVariants = cva('gap-2 border-transparent text-body-foreground', {
  variants: {
    fadable: {
      true: cn(
        'bg-transparent transition-all duration-300',
        'group-has-[[data-role="table-row-link"]:hover]:bg-accent/10',
        'group-has-[[data-role="table-row-link"]:focus-visible]:bg-accent/10'
      ),
      false: '',
    },
  },
  defaultVariants: {
    fadable: false,
  },
})

type PositionBadgeProps = {
  balanceUsd?: number
  className?: string
}

export const PositionBadge = ({
  balanceUsd,
  className,
  fadable = false,
}: PositionBadgeProps & VariantProps<typeof positionBadgeVariants>) => {
  if (!balanceUsd) return null

  return (
    <Badge color="blue" className={cn(positionBadgeVariants({ fadable, className }))}>
      <div className="size-2 min-w-2 rounded-full border border-success bg-success outline outline-2 outline-page" />
      <span
        className={cn(
          fadable &&
            'opacity-0 transition-opacity duration-300 group-has-[[data-role="table-row-link"]:focus-visible]:opacity-100 group-has-[[data-role="table-row-link"]:hover]:opacity-100'
        )}
      >
        {formatUSD(balanceUsd)}
      </span>
    </Badge>
  )
}
